module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[9]252.9a797d1.woff2";